import React, { Fragment } from "react";
import { Link } from "react-router-dom";

// Helper function for scroll behavior
const scrollToTop = () => {
  window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
};

// Dropdown Arrow Component
const DropdownArrow = () => (
  <svg className="dropdown-arrow" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default function Desktopnav() {
 
  return (
    <Fragment>
      <nav className="desktop-nav">
        <ul className="nav-menu">
          {/* The Company Dropdown */}
          <li className="nav-item has-dropdown">
            <span className="nav-link">
              The Company
              <DropdownArrow />
            </span>
            <ul className="dropdown-menu">
              <li>
                <Link to="/about-us" onClick={scrollToTop}>About Us</Link>
              </li>
              <li>
                <Link to="/whoweare" onClick={scrollToTop}>Who We Are</Link>
              </li>
              <li>
                <Link to="/company-details" onClick={scrollToTop}>Company Details</Link>
              </li>
              <li>
                <Link to="/governance" onClick={scrollToTop}>Governance</Link>
              </li>
              <li>
                <Link to="/management" onClick={scrollToTop}>Management</Link>
              </li>
              <li>
                <Link to="/shariah" onClick={scrollToTop}>Shariah Compliance</Link>
              </li>
            </ul>
          </li>

          {/* Products Dropdown */}
          <li className="nav-item has-dropdown">
            <span className="nav-link">
              Products
              <DropdownArrow />
            </span>
            <ul className="dropdown-menu">
              <li>
                <Link to="/Individual-Product" onClick={scrollToTop}>Individual</Link>
              </li>
              <li>
                <Link to="/Corporate-Product" onClick={scrollToTop}>Corporates</Link>
              </li>
              <li>
                <Link to="/Financial-Product" onClick={scrollToTop}>Financial Institutions</Link>
              </li>
            </ul>
          </li>

          {/* Media Dropdown */}
          <li className="nav-item has-dropdown">
            <span className="nav-link">
              Media
              <DropdownArrow />
            </span>
            <ul className="dropdown-menu">
              <li>
                <Link to="/news-and-announcements" onClick={scrollToTop}>News & Announcements</Link>
              </li>
              <li>
                <Link to="/articles-and-blogs" onClick={scrollToTop}>Articles & Blogs</Link>
              </li>
            </ul>
          </li>

          {/* Investor Relations Dropdown */}
          <li className="nav-item has-dropdown">
            <span className="nav-link">
              Investor Relations
              <DropdownArrow />
            </span>
            <ul className="dropdown-menu">
              <li>
                <Link to="/financial-reports" onClick={scrollToTop}>Financial Reports</Link>
              </li>
              <li>
                <Link to="/financial-highlights" onClick={scrollToTop}>Financial Highlights</Link>
              </li>
              <li>
                <Link to="/annual-performance" onClick={scrollToTop}>Annual Performance Review</Link>
              </li>
              <li>
                <Link to="/nogm" onClick={scrollToTop}>Notice of General Meeting</Link>
              </li>
              <li>
                <Link to="/proxy-forms" onClick={scrollToTop}>Proxy Forms</Link>
              </li>
            </ul>
          </li>

          {/* Sustainability Link */}
          <li className="nav-item">
            <Link to="/esg" className="nav-link" onClick={scrollToTop}>Sustainability</Link>
          </li>

          {/* Life @ Salaam Link */}
          <li className="nav-item">
            <Link to="/life-at-salaam" className="nav-link" onClick={scrollToTop}>Life @ Salaam</Link>
          </li>

          {/* Downloads Dropdown */}
          <li className="nav-item has-dropdown">
            <span className="nav-link">
              Downloads
              <DropdownArrow />
            </span>
            <ul className="dropdown-menu">
              <li>
                <Link to="/proposal-form" onClick={scrollToTop}>Proposal Forms</Link>
              </li>
              <li>
                <Link to="/claim-form" onClick={scrollToTop}>Claim Forms</Link>
              </li>
              <li>
                <Link to="/complaint-resolution-form" onClick={scrollToTop}>Complaint Resolution</Link>
              </li>
              {/* <li>
                <Link to="/un-encahsed-form" onClick={scrollToTop}>Un-encashed Benefits/Cheque</Link>
              </li> */}
              <li>
                <Link to="/policies-form" onClick={scrollToTop}>Policies</Link>
              </li>
              <li>
                <Link to="/hospital-form" onClick={scrollToTop}>Panel Hospitals</Link>
              </li>
              <li>
                <Link to="/discount-form" onClick={scrollToTop}>Discount Center</Link>
              </li>
              <li>
                <Link to="/marketing-collateral-forms" onClick={scrollToTop}>Marketing Collateral</Link>
              </li>
              <li>
                <Link to="/other-forms" onClick={scrollToTop}>Other</Link>
              </li>
            </ul>
          </li>

          {/* E-Services Dropdown */}
          <li className="nav-item has-dropdown">
            <span className="nav-link">
              E-Services
              <DropdownArrow />
            </span>
            <ul className="dropdown-menu">
              <li>
                <a href="https://online.salaamtakaful.com/e-verify.aspx" target="_blank" rel="noreferrer">
                  Certificate Verification
                </a>
              </li>
              <li>
                <a href="https://online.salaamtakaful.com/Claim.aspx" target="_blank" rel="noreferrer">
                  Claim Intimation
                </a>
              </li>
              <li>
                <Link to="/compain-box" onClick={scrollToTop}>Complaint Box</Link>
              </li>
            </ul>
          </li>

          {/* Contact Us Link */}
          <li className="nav-item">
            <Link to="/contactus" className="nav-link contact-btn" onClick={scrollToTop}>Contact Us</Link>
          </li>
        </ul>
      </nav>
    </Fragment>
  );
}
